import { render, staticRenderFns } from "./Actreportshipscore.vue?vue&type=template&id=471a7d7a&scoped=true"
import script from "./Actreportshipscore.vue?vue&type=script&lang=js"
export * from "./Actreportshipscore.vue?vue&type=script&lang=js"
import style0 from "./Actreportshipscore.vue?vue&type=style&index=0&id=471a7d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a7d7a",
  null
  
)

export default component.exports